// src/pages/ProjectsPage.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";
import "./ProjectsPage.css";

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();

  /* ---------- FETCH ---------- */
  useEffect(() => {
    let abort = false;

    fetch(`${API_URL}/projects`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.statusText)))
      .then((data) => !abort && setProjects(data))
      .catch((err) => console.error("Projects fetch error:", err));

    return () => {
      abort = true;
    };
  }, []);

  /* ---------- HELPERS ---------- */
  function fmt(dateStr) {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleDateString("pl-PL");            //  dd.mm.rrrr
  }

  /* ---------- RENDER ---------- */
  return (
    <div className="projects-page">
      <section className="projects-left">
        <h2>Projekty</h2>

        <div className="orders-table-container">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Nazwa</th>
                <th>Klient</th>
                <th>Termin</th>
              </tr>
            </thead>

            <tbody>
              {projects.map((p) => (
                <tr
                  key={p.id}
                  className="clickable-row"
                  onClick={() => navigate(`/projekty/${p.id}`)}
                >
                  <td>{p.name}</td>
                  <td>{p.client_name || "—"}</td>
                  <td>{fmt(p.deadline)}</td>
                </tr>
              ))}

              {projects.length === 0 && (
                <tr>
                  <td colSpan={3} className="no-data">
                    Brak projektów do wyświetlenia
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      <aside className="projects-right">
        <button
          className="btn-submit new-project-btn"
          onClick={() => navigate("/projekty/nowy")}
        >
          Utwórz Nowy Projekt
        </button>
      </aside>
    </div>
  );
}
